import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import {BehaviorSubject} from 'rxjs'
import { environment } from './environments/environment';

/**
 * Shared application event and non-authentication API service.
 *
 * Authentication requests are intentionally handled by AuthService so login and
 * password-reset credentials always pass through browser-side encryption first.
 */
@Injectable({
  providedIn: 'root'
})
export class EcitationServiceService {

  url = environment.apiUrl

  private refreshSource = new BehaviorSubject<boolean>(false);
  refresh$ = this.refreshSource.asObservable();

  /**
   * Notifies subscribers that a shared view should refresh its data.
   */
  triggerRefresh(){
    this.refreshSource.next(true)
  }

  constructor( private http:HttpClient) { }

  /**
   * Posts a new user request to eCitation Services.
   *
   * @param userData new user payload collected by the administration form
   * @returns backend user creation response
   */
  addNewUser(userData:any){
    // add new user method
    return this.http.post(this.url+"/ecitation-services/user",userData)
  }
}
